import { useInfiniteItemsListLoader } from '../../../../../hooks'
import { getRequestProfileRatingFeedback } from '../../../../Post'
import {
  checkRequestProfileRatingIsLastPage,
  getRequestProfileRatingItemsData,
  getRequestProfileTabRatingApiParams,
} from '../../RequestProfileTabRating.utils'

export function useRequestProfileTabRatingList({ requestData }) {
  const requestId = requestData?.id

  const apiParams = getRequestProfileTabRatingApiParams(requestId)

  const {
    getThresholdItemProps,
    items,
    loadingInitial,
    loadingMore,
    updateListData,
  } = useInfiniteItemsListLoader({
    apiParams,
    checkIsLastPage: checkRequestProfileRatingIsLastPage,
    getData: getRequestProfileRatingFeedback,
    getDataItems: getRequestProfileRatingItemsData,
    loadPermission: !!requestId,
  })

  return {
    getThresholdItemProps,
    items,
    loading: loadingInitial || loadingMore,
    loadingInitial,
    updateListData,
  }
}
